// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/ea599eeb88b81a88f919.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"9a0ba02a32892eba83ea","144":"80f6c3bd7abe4017e5d9","145":"5409affddfd81826a0f3"}[chunkId] + ".chunk.js";
};